import SpsTruncate from "./SpsTruncate";

export default SpsTruncate;

export { SpsTruncate };
